import { TestResults, TestTestResults } from "@cs124/questioner-types";
import { Array, Boolean, InstanceOf, Partial, Record, String } from "runtypes";
import { Deadline } from "./deadline";
import { Points, SavedPoints } from "./points";
import { SavedSubmission, Submission } from "./submission";
export const SavedResults = SavedSubmission.And(
  Record({
    completed: InstanceOf(Date),
    testingResults: TestResults.Or(TestTestResults)
  })
).And(
  Partial({
    points: Points
  })
);
export const SavedResponse = Record({
  submission: Submission,
  testingResults: TestResults.Or(TestTestResults),
  timestamp: String.Or(InstanceOf(Date)),
  counted: Boolean
}).And(
  Partial({
    deadline: Deadline,
    points: Points,
    cached: Boolean
  })
);
export const PointsWithTimestamp = Points.And(
  Record({
    updated: String.Or(InstanceOf(Date))
  })
);
export const Submissions = Record({
  submissions: Array(SavedResponse)
}).And(
  Partial({
    officialPoints: PointsWithTimestamp
  })
);
export const Response = SavedResponse.And(
  Partial({
    officialPoints: PointsWithTimestamp
  })
);
export const Scores = Record({
  available: Array(Deadline),
  completed: Array(SavedPoints)
});
//# sourceMappingURL=results.js.map
